// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { FormState } from "@hex-insights/forms";
import * as NewsletterOrderFormValues from "../form-values";

export type OrderControllerProps = {
	formState: FormState<NewsletterOrderFormValues.OrderFormValues>;
};

/**
 * Order form of the Newsletter model.
 */
export function OrderController({ formState }: OrderControllerProps) {
	return (
		<IndexForms.OrderFormController
			formState={formState}
			fieldOptions={NewsletterOrderFormValues.fieldOptions}
			fieldTypeMapping={NewsletterOrderFormValues.fieldTypeMapping}
		/>
	);
}
